import { Box, Grid, TextField, Typography, Button, Paper, FormControl, Backdrop, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createStyles, makeStyles } from "@mui/styles";
import { useEffect } from 'react';
import { AddRegistrationNumberAction, GetRegistrationNumberAction } from "../../../../../store/Finance/PayDate/Action";
import { useTheme } from "@mui/material/styles";

const RegistrationNumber = () => {
  const theme = useTheme();
  const useStyles = makeStyles((theme) =>
    createStyles({
      Paper: {
        boxShadow:
          theme.palette.mode === "dark"
            ? "rgb(0 0 0 / 20%) 0px 0px 2px 0px, rgb(0 0 0 / 12%) 0px 12px 24px -4px"
            : "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
        padding: "20px",
        borderRadius: "10px",
        backgroundColor: "#f3edfd",
        position: "relative",
      },
      Backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            position: "absolute",
            borderRadius: "inherit",
        },
    })
  );
  const classes = useStyles();
  const dispatch = useDispatch();
  const { registration_number_data, regNumberLoading } = useSelector(
    (state) => state.FinanceReducer?.PayDateReducer
  );
  const initialData = {
    pf_no: "",
    esi_no: "",
  }
  const [regData, setRegData] = useState(initialData)
  const [errors, setErrors] = useState("");
  const validate = (fieldValues) => {
    let temp = { ...errors };
    // if ("pf_no" in fieldValues) {
    //   temp.pf_no =
    //     fieldValues.pf_no === "" || fieldValues.pf_no === null
    //       ? ""
    //       : fieldValues.pf_no.toString() !== "" &&
    //         !fieldValues.pf_no.toString().match(/^[A-Z]{2}\/[A-Z]{3}\/\d{7}\/\d{3}\/\d{7}$/)
    //         ? "Invalid EPF Number."
    //         : "";
    // }
    if ("esi_no" in fieldValues) {
      temp.esi_no =
        fieldValues.esi_no === "" || fieldValues.esi_no === null
          ? ""
          : fieldValues.esi_no.toString() !== "" &&
            !fieldValues.esi_no.toString().match(/^\d{17}$/)
            ? "Invalid ESI Number."
            : "";
    }
    setErrors({
      ...temp,
    });
    const temp1 = { ...temp };
    return Object.values(temp1).every((x) => x === "");
  };
  const handleInputChange = (event, value) => {
      setRegData({
        ...regData,
        [event.target.name]: event.target.value,
      });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...regData, [event.target.name]: event.target.value });
    
  };
  const handleSubmit = () => {
    if(!validate(regData)) return;

    dispatch(AddRegistrationNumberAction({
        pf_no: regData?.pf_no,
        esi_no: regData?.esi_no,
    }));
  };
  useEffect(() => {
    dispatch(GetRegistrationNumberAction())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  useEffect(() => {
    if (registration_number_data) {
        setRegData({
            pf_no: registration_number_data?.pf_no || "",
            esi_no: registration_number_data?.esi_no || "",
        });
    }
  }, [registration_number_data]);
  return (
      <Grid item xs={12}>
        <Grid item xs={12} md={12} sx={{ display: "flex", justifyContent: "left" }}>
          <Paper
            className={classes.Paper}
            sx={{
              padding: "10px 0px", borderRadius: "16px",
              width: "100%",
              minHeight: "140px"
            }}
          >
            <Backdrop className={classes.Backdrop} open={regNumberLoading}>
                <CircularProgress />
            </Backdrop>
            <Box sx={{ display: "flex", alignItems: "start", justifyContent: "space-between" }}>
              <Grid container spacing={2}>
                <Grid key="name" item xs={10}>
                    <FormControl fullWidth >
                        <TextField
                            size="small"
                            value={regData?.pf_no || ""}
                            onChange={handleInputChange}
                            variant="outlined"
                            label="EPF Number"
                            name="pf_no"
                            placeholder="AB/XYZ/1234567..."
                            sx={{
                                "& input::placeholder": {
                                color: "#B0B0B0",
                                },
                            }}
                            {...(errors.pf_no && {
                                error: true,
                                helperText: errors.pf_no,
                            })}
                        />
                    </FormControl>
                </Grid>
                <Grid  item xs={10}>
                    <FormControl fullWidth >
                        <TextField
                            size="small"
                            value={regData?.esi_no || ""}
                            onChange={handleInputChange}
                            variant="outlined"
                            label="ESI Number"
                            placeholder="12345678901234567"
                            name="esi_no"
                            sx={{
                            "& input::placeholder": {
                                color: "#B0B0B0",
                            },
                            }}
                            {...(errors.esi_no && {
                                error: true,
                                helperText: errors.esi_no,
                            })}
                        />
                    </FormControl>
                </Grid>
            </Grid>
              <Box>
                <Button
                        variant="contained"
                        className="mpl-primary-btn"
                        onClick={handleSubmit}
                        size="medium">
                        Save
                    </Button>
              </Box>
            </Box>
            <Grid container display="flex" justifyContent="space-between" alignItems="center" sx={{ marginTop: "20px" }}>
                <Grid item xs={12} >
                    <Typography
                    variant="body1"
                    sx={{
                        padding: "10px",
                        backgroundColor: theme.palette.grey[200],
                        borderRadius: "5px",
                    }}
                    >
                    {"Please enter registered EPF & ESI numbers of the organization for successful EPFO ECR report generation"}
                    </Typography>
                </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
  );
};

export default RegistrationNumber;
